<template>
    <div>
        <link rel="stylesheet" href="//res.wx.qq.com/open/libs/weui/0.4.3/weui.min.css">
        <div class="app-screen" slot="container">
            <div class="error-container" :data-key="errorCode">
                <i class="weui_icon_msg weui_icon_warn"></i>
                <div class="error-message">{{errorMessage}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    // import ScrollPullDown from '@/public/ScrollPullDown'
    import Core from '@/until/core'
    export default {
        name: 'ErrorMessage',
        data () {
            return {
                message: {
                    error_undefined: '未知错误, 请尝试关闭页面后重新打开',
                    no_available_ports_were_found: '没有找到可用端口, 请稍候再试',
                    please_use_wechat_to_open_it: '请使用微信内部浏览器打开!!',
                    page_authorization_failure: '页面授权失败, 请稍候再试'
                }
            }
        },
        components: {
            // ScrollPullDown
        },
        watch: {},
        computed: {
            errorCode () {
                const errorCode = (this.$route.query.message || '').toLowerCase()
                if (Object.prototype.hasOwnProperty.call(this.message, errorCode)) {
                    return errorCode
                }
                return 'error_undefined'
            },
            errorMessage () {
                return this.message[this.errorCode]
            }
        },
        filters: {},
        methods: {},
        mounted () {
            const that = this
            if (that.errorCode === 'please_use_wechat_to_open_it') {
                if (parseInt(that.$route.params.Uid, 10) > 0 && that.$route.params.ShareId) {
                    Core.weChatJsdk([]).then((platForm) => {
                        if (platForm && platForm.isWx) {
                            // 微信中打开
                            wx.hideOptionMenu()
                            return that.$router.push({path: that.$route.query.source, params: that.$route.params, query: that.$route.query})
                        } else if (platForm) {
                            // 非微信浏览器打开
                            return that.$router.push({name: 'MobileEnroll', params: that.$route.params, query: that.$route.query})
                        }
                    })
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
    .error-container{ padding-top: 50px; padding-right: 30px; padding-left: 30px; text-align: center; }
    .error-message{ line-height: 35px; padding-top: 20px; }
</style>



// WEBPACK FOOTER //
// src/components/ErrorMessage.vue